<template>
    <div>
        <el-page-header @back="goBack" content="专家详情"></el-page-header>
        <div class="bigbox" :style="{padding:bigbox_padding}">
            <div class="docher_conter">
                <div class="headers">
                    <div class="yemT">专家介绍</div>
                    <div>
                        <el-button type="primary" @click="goEdit">编辑</el-button>
                        <!--                    <el-button type="primary" @click="export2Excel">导出</el-button>-->
                        <el-button type="primary" @click="getExpertInfo">导出</el-button>
                        <el-button type="danger" @click="deleteExpert">删除</el-button>
                    </div>
                </div>
                <div class="doce" ref="print">
                    <div class="left_imgbox">
                        <img :src="user_avatar" alt="">
                        <div class="bixif" v-if="expertData.degree">
                            <span>学位：</span>
                            <span>{{ expertData.degree }}</span>
                        </div>
                        <div class="bixif" v-if="expertData.degree">
                            <span>年龄：</span>
                            <span>{{ expertData.age }}</span>
                        </div>
                        <div class="bixif">
                            <span>手机：</span>
                            <span>{{ expertData.mobile }}</span>
                        </div>
                        <div class="bixif" style="flex-direction:column;" v-for="(item,index) in attendant_list" :key="index">
                            <span style="line-height:2.4" v-if="!index">特属服务专员：</span>
                            <div style="line-height:1.5;padding-left:55px;text-align:left">
                                <el-button type="text" @click="goOperateDetail(item)">
                                    <span style="color: #6B99F0;">{{ item.name }}：</span>
                                    <span style="color: #6B99F0;">{{ item.mobile }} </span>
                                </el-button>
                            </div>
                        </div>


                    </div>
                    <div class="baini" :style="{marginLeft:baini_margin_left}">
                        <div class="center_doc">
                            <span class="left_txt">{{ expertData.user_name }}</span>
                            <span class="right_txt">{{ expertData.doctor_title }}</span>
                        </div>
                        <div class="center_doc">
                            <span class="xiaom">单位</span>
                            <span class="right_txt">{{ expertData.hospital }}</span>
                        </div>
                        <div class="center_doc">
                            <span class="xiaom">科室</span>
                            <span class="right_txt">{{ expertData.hospital_department }}</span>
                        </div>
                        <div class="center_doc">
                            <span class="xiaom">职务</span>
                            <span class="right_txt">{{ expertData.posistion }}</span>
                        </div>
                        <div class="center_xiaj">
                            <span class="xiaom">专长</span>
                            <span class="right_txt" :style="{paddingRight:right_txt_padding_left}">{{ expertData.strengths }}</span>
                        </div>
                        <div class="center_xiaj">
                            <span class="xiaom">学术任职</span>
                            <span class="right_txt" :style="{paddingRight:right_txt_padding_left}">{{ expertData.introduction }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="docher_conter faont">
                <div class="headers">
                    <div class="yemT">其他信息</div>
                </div>
                <div class="uashd">
                    <table class="yaocew">
                        <tr>
                            <th>身份证</th>
                            <th>银行卡</th>
                            <th>签约时间</th>
                            <th>签约上限</th>
                            <th>已签约人数</th>
                        </tr>
                        <tr>
                            <td>{{ doctorData.idcard }}</td>
                            <td v-if="expertData.bank_name">{{ expertData.bank_card }}({{expertData.bank_name}})</td>
                            <td v-else>{{ expertData.bank_card }}</td>
                            <td>{{ protocolData.start_date }}</td>
                            <td>{{ doctorData.max_client }}</td>
                            <td>{{ doctorData.reservation_num }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="docher_conter grid-content bg-purple detail_diagnosis">
                <div class="headers">
                    <div class="yemT">签约协议</div>
                </div>
                <div class="detail_content doce">
                    <div>
                        <ul class="el-upload-list el-upload-list--picture-card">
                            <li tabindex="0" class="el-upload-list__item is-ready" v-for="(img, index) in protocolFileList">
                                <div>
                                    <pdf :src="img.url" v-if="getFileType(img.url) == 'pdf'"></pdf>
                                    <img :src="img.url" alt="" class="el-upload-list__item-thumbnail" v-if="getFileType(img.url) != 'pdf'">
                                    <span class="el-upload-list__item-actions" @click="previewImage(protocolFileList, index, '签约协议预览')">
                                                    <span class="el-upload-list__item-preview"><i
                                                        class="el-icon-zoom-in"></i></span>
                                                </span>
                                </div>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
            <div class="docher_conter grid-content bg-purple detail_diagnosis">
                <div class="headers">
                    <div class="yemT">其他附件</div>
                </div>
                <div class="detail_content doce" :style="{paddingLeft:doc_padding_left}">
                    <div>
                        <ul class="el-upload-list el-upload-list--picture-card">
                            <li tabindex="0" class="el-upload-list__item is-ready" v-for="(img, index) in fileList">
                                <div>
                                    <img :src="img.url" alt="" class="el-upload-list__item-thumbnail">
                                    <span class="el-upload-list__item-actions" @click="previewImage(fileList, index, '其他附件预览')">
                                                    <span class="el-upload-list__item-preview"><i
                                                        class="el-icon-zoom-in"></i></span>
                                                </span>
                                </div>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
            <div class="anniu" @click="backToList">返回</div>
        </div>
        <el-dialog :title="preview_title" :visible.sync="dialogContractFormVisible">
            <el-carousel ref="image_box" id="image_detail" indicator-position="outside" height="700px" :autoplay="false" :initial-index="0" :loop="false">
                <el-carousel-item v-for="url in imageUrl" >
                    <div class="image_box" v-if="getFileType(url.src) == 'pdf'">
                        <pdf
                            v-for="i in url.pages"
                            :key="i"
                            :page="i"
                            :src="url.src" ></pdf>
                    </div>
                    <div class="image_box" v-if="getFileType(url.src) != 'pdf'">
                        <el-image :src="url.src"></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>
    </div>

</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {check} from "@/utils/checkData";
import {authUrlCheck, base64Parser, fileType, getBase64Image, isMobile, loadFile} from "@/api/order";
import PizZip from "pizzip";
import {saveAs} from "file-saver";
import Docxtemplater from "docxtemplater";
import ImageModule from "docxtemplater-image-module-free";
import {VueCropper} from "vue-cropper";
import pdf from "vue-pdf";

export default {
    components: {
        pdf
    },
    data() {
        return {
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            user_id: '',
            user_avatar:'',
            expertData: {},
            protocolData: {},
            managerList: [],
            attendant_list: [],
            operateUserLeader: {},
            fileList: [],
            addFileList: [],
            imageUrl: [],
            protocolFileList: [],
            addProtocolFileList: [],
            protocolImageUrl: [],
            dialogContractFormVisible: false,
            doctorData: {
                idcard: '',
                expired_date: '',
                max_client: '',
                reservation_num: '',
            },
            preview_title: '',
            doc_padding_left: "90px",
            baini_margin_left: "80px",
            right_txt_padding_left: "260px",
            bigbox_padding: "0 40px",
        }
    },
    mounted() {

    },
    async created() {
        if (isMobile()) {
            this.doc_padding_left = '0'
            this.baini_margin_left = '20px'
            this.right_txt_padding_left = '0'
            this.bigbox_padding = '0 10px'
        }
        localStorage.setItem('prev_page', 'expert_detail')
        if (this.$route.query.user_id && this.$route.query.user_id != "") {
            this.user_id = this.$route.query.user_id;
            await this.getData();
        }
    },
    methods: {
        getFileType(url) {
            return fileType(url)
        },
        async getData() {
            let params = {
                servername: 'Ruyi_AdminDoctorServices',
                method: 'expertView',
                params: {
                    user_id: this.user_id
                }
            };
            await this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.expertData = res.data.data.exportData;

                if (res.data.data.doctorData != null)
                    this.doctorData = res.data.data.doctorData;

                if (res.data.data.managerList) {
                    this.managerList = res.data.data.managerList;
                }
                if (res.data.data.attendant_list) {
                    this.attendant_list = res.data.data.attendant_list;
                }

                let allFile = [];
                if (res.data.data.exportData.idcard_img_up) {
                    allFile.push({
                        name: '身份证正面照片',
                        url: this.imgUrl + res.data.data.exportData.idcard_img_up
                    });
                    this.addFileList.push(this.imgUrl + res.data.data.exportData.idcard_img_up)
                }

                if (res.data.data.exportData.idcard_img_down) {
                    allFile.push({
                        name: '身份证反面照片',
                        url: this.imgUrl + res.data.data.exportData.idcard_img_down
                    });
                    this.addFileList.push(this.imgUrl + res.data.data.exportData.idcard_img_down)
                }
                if (res.data.data.exportData.bankcard_img) {
                    allFile.push({
                        name: '银行卡照片',
                        url: this.imgUrl + res.data.data.exportData.bankcard_img
                    });
                    this.addFileList.push(this.imgUrl + res.data.data.exportData.bankcard_img)
                }
                this.fileList = allFile;
                if (res.data.data.protocolData) {
                    this.protocolData = res.data.data.protocolData;
                    let protocolFile = JSON.parse(res.data.data.protocolData.contract_file)
                    let allProtocolFile = [];
                    for (let i = 0; i < protocolFile.length; i++) {
                        // console.log(protocolFile[i])
                        allProtocolFile.push({
                            url: this.imgUrl + protocolFile[i].file
                        })
                    }
                    this.protocolFileList = allProtocolFile
                }
                if (res.data.data.exportData.user_avatar) {
                    this.user_avatar = this.imgUrl + res.data.data.exportData.user_avatar
                }


            });
        },
        // 返回上一页
        goBack() {
            window.history.go(-1);
            return;
        },
        goEdit() {
            this.$router.push({name: "expertAdd", query: {user_id: this.user_id}});
        },
        // 服务人员详情页
        goOperateDetail(data) {
            this.$router.push({
                name: "operatorUserDetail",
                params: {
                    id: data.id,
                }
            });
        },
        goAdminList(data) {
            this.$router.push({
                name: "administratorsList",
                params: {
                    user_name: data.user_name,
                }
            });
        },
        backToList() {
            this.$router.push({name: "expertList"});
        },
        deleteExpert() {
            this.$confirm('确定删除该专家吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    servername: 'Ruyi_AdminDoctorServices',
                    method: 'deleteExpert',
                    params: {
                        user_id: this.user_id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.$message({
                        type: "success",
                        message: "删除成功！",
                    });
                    this.backToList();

                });
            }).catch(() => {
            });
        },
        export2Excel() {

            var a = document.createElement("a");
            var url = window.URL.createObjectURL(
                new Blob([this.gethtml()], {
                    type: ''
                })
            );
            a.href = url;
            a.download = "file.html";
            a.click();
            window.URL.revokeObjectURL(url);
        },
        gethtml() {
            const template = this.$refs.print.innerHTML;
            let html = `<!DOCTYPE html>
            <html>
            <head>
            <meta charset="utf-8">
            <meta name="viewport" content="width=device-width,initial-scale=1.0">
            <title></title>
            <link rel="stylesheet" href="http://ruyi.9leaf.com/frontweb/print.css" />
            </head>
            <body>
            <div class="resume_preview_page" style="margin:0 auto;width:1200px">

            ${template}
            </div>
            </body>
            </html>`;
            return html;
        },

        // 获取专家导出资料
        getExpertInfo() {
            let params = {
                servername: 'Ruyi_AdminDoctorServices',
                method: 'exportDoctor',
                params: {
                    doctor_id: this.user_id
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.all_expert = res.data.data

                this.$confirm(`<b style="font-size: 16px;">专家资料已成功生成pdf文件, 是否确定下载</b><br />下载链接：<a style="color: #0057fb;" href="${env.IMG_COMMON_URL_PREFIX+ res.data.data.download_file}" download="${res.data.data.file_name}">${env.IMG_COMMON_URL_PREFIX+ res.data.data.download_file}</a>`, '', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定下载',
                    cancelButtonText: '取消',
                }).then(() => {
                    this.downloadPdf(env.IMG_COMMON_URL_PREFIX+ res.data.data.download_file, res.data.data.file_name)
                }).catch(()=>{});

                // this.importWord(res.data.data)
            });
        },
        downloadPdf(url, fileName){
            let x = new XMLHttpRequest();
            x.open("GET", url, true);
            x.responseType = 'blob';
            x.onload=function(e) {
                let url = window.URL.createObjectURL(x.response)
                let a = document.createElement('a');
                a.href = url
                a.download = fileName;
                a.click()
            }
            x.send();

        },
        // 图片预览
        async previewImage(data, index, title){
            if (this.$refs.image_box) {
                this.$refs.image_box.setActiveItem(index)
            }
            this.imageUrl = [];
            if (data.length > 0) {
                let url = '';
                let local_url = '';
                let num_pages = 0;
                for (let i = 0; i < data.length; i++) {
                    // this.imageUrl.push(data[i].url);
                    local_url = url = data[i].url;
                    num_pages = 0;
                    if (this.getFileType(url) == 'pdf') {
                        url = pdf.createLoadingTask(url)
                        await url.promise.then(pdf => {
                            num_pages = pdf.numPages
                            this.imageUrl.push({
                                src: local_url,
                                pages: num_pages
                            });
                        }).catch((e)=>{});

                    } else {
                        this.imageUrl.push({
                            src: local_url,
                            pages: num_pages
                        });
                    }
                }
            }
            this.preview_title = title
            this.active_index = index
            this.dialogContractFormVisible = true;

        },

        // 专家资料导出到word
        async importWord(data) {
            let newDataArr = [];

            let len = data.length;
            let manager1 = '';
            let manager2 = '';
            for (let i = 0; i < len; i++) {
                manager1 = data[i].asissant[0] ? `${data[i].asissant[0].name}(${data[i].asissant[0].mobile})` : '暂无';
                manager2 = data[i].asissant[1] ? `${data[i].asissant[1].name}(${data[i].asissant[1].mobile})` : '';

                newDataArr.push({
                    "name": data[i].user_name,
                    "doctor_title": data[i].doctor_title,
                    "hospital": data[i].hospital,
                    "hospital_department": data[i].hospital_department,
                    "strengths": data[i].strengths,
                    "introduction": data[i].introduction,
                    "avatar": await getBase64Image(env.IMG_COMMON_URL_PREFIX + data[i].user_avatar),
                    "degree": data[i].degree,
                    "working_year": data[i].working_year,
                    "mobile": data[i].mobile,
                    "mname1": manager1,
                    "mname2": manager2,

                })
            }

            loadFile(
                "doctor-info.docx",
                function (error, content) {

                    if (error) {
                        throw error;
                    }
                    const zip = new PizZip(content);

                    let imageOpts = {}
                    imageOpts.centered = true;  // 图片居中，在word模板中定义方式为{%%image}
                    imageOpts.fileType = "docx";
                    imageOpts.getImage = function (newImgUrl) {
                        return base64Parser(newImgUrl);
                    }
                    imageOpts.getSize = function () {
                        return [140, 140]
                    }

                    const doc = new Docxtemplater(zip, {
                        paragraphLoop: true,
                        linebreaks: true,
                        modules: [new ImageModule(imageOpts)],
                    });

                    doc.render({
                        "doctor": newDataArr
                    });

                    const out = doc.getZip().generate({
                        type: "blob",
                        mimeType:
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    });
                    // Output the document using Data-URI
                    saveAs(out, "专家资料.docx");

                }
            );

        }
    }
}

</script>
<style lang="scss">
.container-transform {
    min-width: 580px;
}
.bigbox {
    min-width: 500px;
    max-width: 1200px;
    height: auto;
    display: flex;
    flex-direction: column;
    padding: 0 40px;
    box-sizing: border-box;
    margin: 0 auto;

    .faont {
        padding-bottom: 50px;
        border-bottom: 1px solid #f9f9f9;
    }

    .docher_conter {
        width: 100%;
        height: auto;
        padding-top: 30px;


        .headers {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .yemT {
                font-weight: 650;
                font-style: normal;
                font-size: 20px;
                color: #333;
                padding-left: 25px;
            }

            .aniub {
                display: flex;
                align-items: center;

                span {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 80px;
                    height: 35px;
                    font-size: 13px;
                    color: #fff;
                    background-color: rgba(0, 153, 255, 1);
                    box-sizing: border-box;
                    border-width: 1px;
                    border-style: solid;
                    border-color: rgba(0, 121, 254, 1);
                    border-radius: 3px;
                    cursor: pointer;

                }

                .biaji {
                    margin-right: 60px;

                }
            }
        }

        .doce {
            width: 100%;
            display: flex;
            margin-top: 55px;
            box-sizing: border-box;
            padding-bottom: 50px;
            border-bottom: 1px solid #f9f9f9;

            .left_imgbox {
                width: 200px;
                height: auto;

                img {
                    width: 183px;
                    height: 183px;
                }

                .bixif {
                    display: flex;
                    line-height: 3;

                    span {
                        font-size: 14px;
                        color: #333;
                        text-align: left;
                    }
                }
            }

            .baini {
                flex: 1;

                .center_doc {
                    display: flex;
                    align-items: flex-end;
                    margin-bottom: 17px;

                    .left_txt {
                        font-size: 20px;
                        font-weight: 650;
                        font-style: normal;
                        color: #333;
                        margin-right: 35px;
                    }

                    .right_txt {
                        font-size: 14px;
                        color: #999;

                    }

                    .xiaom {
                        font-size: 14px;
                        font-weight: 650;
                        font-style: normal;
                        color: #333;
                        margin-right: 25px;
                    }
                }

                .center_xiaj {
                    display: flex;
                    // align-items: flex-end;
                    margin-top: 55px;

                    .right_txt {
                        font-size: 14px;
                        color: #999;
                        flex: 1;
                        padding-right: 260px;
                        line-height: 24px;
                    }

                    .xiaom {
                        font-size: 14px;
                        font-weight: 650;
                        font-style: normal;
                        color: #333;
                        margin-right: 25px;
                        // width: 28px;

                    }
                }
            }
        }

        .uashd {
            width: 100%;
            height: auto;
            margin: 0 auto;
            margin-top: 35px;


            .yaocew {
                width: 100%;
                height: auto;
                border: 1;

                tr {
                    display: table-row;
                    vertical-align: inherit;
                    border-color: inherit;
                }

                th,
                td {
                    border: 1px solid #ccc;
                    height: 45px;
                    text-align: center;
                    line-height: 45px;
                }

                th {
                    background-color: #f6f6f6;
                    font-size: 14px;
                    color: #666;
                    font-weight: 600;
                }

                td {
                    font-size: 12px;
                    color: #333;
                }
            }
        }
    }
}

.anniu {
    width: 140px;
    height: 33px;
    background-color: rgba(0, 153, 255, 1);
    font-size: 13px;
    color: #fff;
    text-align: center;
    line-height: 33px;
    border-radius: 4px;
    margin: 50px auto;
    cursor: pointer;
}

table {
    border: 0;
    border-collapse: collapse;
}

.right_txt {
    text-align: left;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    white-space: pre-line
    //-webkit-line-clamp: 4;
    //overflow: hidden;
}

.detail_diagnosis {
    text-align: left;

    .detail_content {
        line-height: 1.5em;
    }

}
.image_box {
    height: 700px;
    overflow: hidden;
    overflow-y: auto;

    image {
        width: 100%;
    }
}
</style>
